import { getSystemTypes } from "../../../../axios/api/services";
import createAppDataSliceAndThunk from "./appDataSlice";

const [asyncThunk, slice] = createAppDataSliceAndThunk("systemTypes", getSystemTypes);

export const systemTypesThunk = asyncThunk;

export default slice.reducer;
